export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "product_informations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations produit"])},
        "connected_device": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Appareil connecté"])},
        "internet_tv_offer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offre internet et/ou TV"])}
      },
      "en": {
        "product_informations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Product information"])},
        "connected_device": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connected device"])},
        "internet_tv_offer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Internet and/or TV offer"])}
      }
    }
  })
}
